module.exports = __webpack_public_path__ + "img/8a_Cameras.d2fc43d5.png";